"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: insights/insights-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Finsights%2Finsights-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightsServiceClient = exports.GetUserInsightsResponse = exports.GetUserInsightsRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const insights_data_1 = require("./insights-data");
const insights_enum_1 = require("./insights-enum");
const protobufPackage = 'com.step.insights.proto';
function createBaseGetUserInsightsRequest() {
    return { interval: insights_enum_1.Interval.INVALID_INTERVAL, targetDateMs: '0' };
}
exports.GetUserInsightsRequest = {
    fromJSON(object) {
        const message = {
            interval: isSet(object.interval)
                ? (0, insights_enum_1.intervalFromJSON)(object.interval)
                : insights_enum_1.Interval.INVALID_INTERVAL,
            targetDateMs: isSet(object.targetDateMs) ? globalThis.String(object.targetDateMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.interval !== insights_enum_1.Interval.INVALID_INTERVAL) {
            obj.interval = (0, insights_enum_1.intervalToJSON)(message.interval);
        }
        if (message.targetDateMs !== '0') {
            obj.targetDateMs = message.targetDateMs;
        }
        return obj;
    },
    create(base) {
        return exports.GetUserInsightsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserInsightsRequest();
        message.interval = object.interval ?? insights_enum_1.Interval.INVALID_INTERVAL;
        message.targetDateMs = object.targetDateMs ?? '0';
        return message;
    },
};
function createBaseGetUserInsightsResponse() {
    return { insights: undefined };
}
exports.GetUserInsightsResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.insights)) {
            message.insights = insights_data_1.UserInsights.fromJSON(object.insights);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.insights !== undefined) {
            obj.insights = insights_data_1.UserInsights.toJSON(message.insights);
        }
        return obj;
    },
    create(base) {
        return exports.GetUserInsightsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserInsightsResponse();
        message.insights = (object.insights !== undefined && object.insights !== null)
            ? insights_data_1.UserInsights.fromPartial(object.insights)
            : undefined;
        return message;
    },
};
/**
 * Insights Service API.
 *
 * Serves insight data via reports found in the Postgres DB.
 */
class InsightsServiceClient {
    rpc;
    name = 'com.step.insights.proto.InsightsService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/insights';
    methods = [{
            name: 'GetUserInsights',
            requestType: exports.GetUserInsightsRequest,
            responseType: exports.GetUserInsightsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Get a users insights
     */
    getUserInsights(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.InsightsServiceClient = InsightsServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=insights-service.js.map